import { render } from "./restyle_footer_mobile.vue?vue&type=template&id=865790dc&scoped=true"
import script from "./restyle_footer_mobile.vue?vue&type=script&lang=js"
export * from "./restyle_footer_mobile.vue?vue&type=script&lang=js"

import "./restyle_footer_mobile.vue?vue&type=style&index=0&id=865790dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-865790dc"]])

export default __exports__